module.exports = __webpack_public_path__ + "img/element-plus-logo.5cc20986.svg";